import * as React from 'react';
import {
  useProfilePhoto,
  UseProfilePhotoProps,
} from '@/components/ui/hooks/useProfilePhoto';
import { UserCircle, Upload } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
// import { Button } from './button';
// import { Alert, AlertDescription } from './alert';
// import ErrorMessage from '../ErrorMessage';

export interface ProfilePhotoInputProps
  extends Omit<
      React.InputHTMLAttributes<HTMLInputElement>,
      'value' | 'onChange'
    >,
    UseProfilePhotoProps {
  containerClassName?: string;
}

const ProfilePhotoInput = React.forwardRef<
  HTMLInputElement,
  ProfilePhotoInputProps
>(
  (
    { className, containerClassName, onChange, value, maxSize, ...props },
    forwardedRef
  ) => {
    const {
      imagePreview,
      getRootProps,
      getInputProps,
      isDragActive,
      // removeImage,
      // error,
    } = useProfilePhoto({ maxSize, onChange, value });
    const inputRef = React.useRef<HTMLInputElement>(null);

    React.useImperativeHandle(forwardedRef, () => inputRef.current!, []);

    const handleClick = () => {
      inputRef.current?.click();
    };

    return (
      <div className={cn('flex flex-col items-center', containerClassName)}>
        <div className="relative">
          {' '}
          <div
            {...getRootProps()}
            className={cn(
              'relative w-48 h-48 rounded-full border-2 border-dashed overflow-hidden',
              isDragActive ? 'border-primary' : 'border-input',
              'hover:border-primary transition-colors group',
              className
            )}
          >
            <input
              {...getInputProps()}
              ref={inputRef}
              aria-label="Upload profile photo"
              {...props}
            />
            <Avatar className="w-full h-full">
              <AvatarImage
                src={imagePreview || undefined}
                alt="Profile preview"
                className="object-cover"
              />
              <AvatarFallback>
                <UserCircle className="w-24 h-24 text-muted-foreground" />
              </AvatarFallback>
            </Avatar>
            <div
              className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
              onClick={handleClick}
            >
              <Upload className="w-12 h-12 text-white" />
            </div>
          </div>
          {/* {imagePreview && (
            <Button
              onClick={() => removeImage()}
              variant="destructive"
              size="icon"
              type="button"
              className="mt-4 absolute bottom-0 right-0 z-50"
              aria-label="Remove profile photo"
            >
              <XIcon className="w-5 h-5" />
            </Button>
          )} */}
        </div>
        {/* {error && (
          <div className="mt-4 max-w-md">
            <ErrorMessage error={error} />
          </div>
        )} */}
        {/* Uncomment to enable photo upload */}
      </div>
    );
  }
);
ProfilePhotoInput.displayName = 'ProfilePhotoInput';

export { ProfilePhotoInput };
